module.exports = __webpack_public_path__ + "static/media/full-screen.af44f67f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/full-screen.svg
// module id = 69
// module chunks = 0